<!-- ==============================
  File Name: LeadAdd.vue
  Description: Lead Add page
=============================== -->

<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-6" v-if="userIsManagerOrAdmin">
            <label class="text-sm">Select Partner*</label>
            <v-select
              :options="partners"
              :reduce="item => item.value" label="label"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
              @input="getCodesVal(Lead.Partner)"
              class="w-full"
              name="Partner"
              :value="Lead.Partner"
              v-model="Lead.Partner"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('Partner') && isSaveForm"
            >{{ errors.first('Partner') }}.</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm">Select Code*</label>
            <v-select
              :options="codes"
              :reduce="item => item.value" label="label"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              v-validate="'required'"
              class="w-full"
              name="Code"
              :value="Lead.Code"
              v-model="Lead.Code"
            />
            <a href="#" @click="checkIsPartnerExist()">Add Code</a>
            <span
              style="padding-left:20px"
              class="text-danger text-sm"
              v-show="errors.has('Code') && isSaveForm"
            >{{ errors.first('Code') }}.</span>
            
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full" label-placeholder="Phone" name="Phone" v-validate="Lead.Email ? '' : 'required'" v-model="Lead.Phone" @input="isEmailPhoneValid()"/>
            <span
              class="text-danger text-sm"
              v-show="(errors.has('Phone') && isSaveForm) || isPhoneError"
            >{{phoneErrorMessage}}.</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input
              type = "email"
              class="w-full"
              name = "Email"
              v-validate="Lead.Phone ? '' : 'required'" 
              label-placeholder="Email"
              v-model="Lead.Email"
              @input="isEmailPhoneValid()"
            />
            <span
              class="text-danger text-sm"
              v-show="(errors.has('Email') && isSaveForm) || isEmailError"
            >{{emailErrorMessage}}</span>
            </div>
          </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input
              class="w-full"
              label-placeholder="Company Name*"
              name="CompanyName"
              v-validate="'required'"
              v-model="Lead.CompanyName"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('CompanyName') && isSaveForm"
            >Company Name field is required.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click.prevent="saveLead">Save</vs-button>
            <vs-button
              color="warning"
              type="border"
              class="mb-2"
              @click.native="$router.push('/apps/leads/list')"
            >Cancel</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
    <div class="demo-alignment">
      <vs-popup classContent="popup-example" title="Add Code" :active.sync="codePopup">
        <div class="vx-row">
          <div class="vx-col w-full mb-6">
            <vs-input
              class="w-full"
              name="CodeName"
              label-placeholder="Code Name*"
              v-model="Code.CodeName"
              @blur="checkCodename($event)"
              v-on:keyup="checkCode(Code.CodeName)"
            />
            <span
              class="text-danger text-sm"
              v-if="isPrimaryCodeExist"
            >Code name already exists.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-6">
            <flat-pickr :config="configStartDateTimePicker" class="w-full" v-model="Code.StartDate" placeholder="Start Date"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full mb-6">
            <flat-pickr v-if="!isChecked" :config="configEndDateTimePicker" class="w-full" v-model="Code.ExpiryDate" placeholder="Expiry Date"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2 mt-5">
            <vs-checkbox v-model="isChecked">Primary</vs-checkbox>
          </div>
        </div>
        <div class="vx-row mt-5">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click.prevent="saveCode">Save</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="codePopup=false">Cancel</vs-button>
          </div>
        </div>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import "@/assets/css/main.css";
import LeadService from "@/services/LeadService";
import PartnerCodesService from "@/services/PartnerCodesService";
import PartnerService from "@/services/PartnerService";
import UtilService from "@/services/UtilService";
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
export default {
  data() {
    return {
      configStartDateTimePicker: {
        dateFormat: "Y-m-d h:i K",
      },
      configEndDateTimePicker: {
        dateFormat: "Y-m-d 11:59 P\\M",
      },
      userInfo: {},
      isChecked: false,
      codePopup: false,
      oldPartnerValue: "",
      isPrimaryCodeExist: false,
      Code: {
        Id: "",
        Partner: "",
        CodeName: "",
        StartDate: "",
        ExpiryDate: "",
        Primary: "No",
        IsDeleted: 0,
        CreatedBy: "",
        Status: "Active",
        ModifiedBy: ""
      },
      Lead: {
        Id: "",
        CompanyName: "",
        Partner: "",
        Code: "",
        Email: "",
        Phone: "",
        IsConverted:0,
        IsDeleted: 0,
        CreatedBy: "",
        ModifiedBy: "",
        ModifiedDate: Date,
      },
      partners: [],
      codes: [],
      emailErrorMessage: "Phone or Email field is mandatory.",
      phoneErrorMessage: "Phone or Email field is mandatory.",
      isEmailError: false,
      isPhoneError:false,
      isSaveForm: false,
    };
  },
  components: {
    "v-select": vSelect,
    flatPickr
  },
  methods: {
    checkCodename(event) {
      if (event.target.value !== "") {
        PartnerCodesService.checkDuplicateCode(event.target.value, (isExists) => {
          if(isExists != null){
            this.isPrimaryCodeExist = isExists;
          }
        });
      } else {
        this.isPrimaryCodeExist = false;
      }
    },
    checkCode(CodeName){
      this.Code.CodeName = CodeName.toUpperCase();
      let char = String.fromCharCode(CodeName); 
      if(/[A-Za-z0-9]/.test(char)) return true; 
      else false; 
    },
    fetchLeadData(leadId) {
      LeadService.getById(leadId).once("value", item => {
        if (item && item.val()) {
          let lead = item.val();
          this.oldPartnerValue = lead.Partner;
          PartnerCodesService.getById(lead.Code).once('value', item => {
            if(item && item.val()){
              let data = item.val();
              lead.Code = data['CodeName'];
              this.Lead = {...lead};
            }
            else{
              this.Lead = {...lead};
            }
            this.getCodesVal(lead.Partner);
          })
        }
      });
    },
    saveLead() {
      this.isSaveForm = true;
      this.$validator.validateAll().then(result => {
      this.isEmailError = false;
      this.isPhoneError = false;
      this.emailErrorMessage = '';
      this.phoneErrorMessage = '';
      let validEmail = UtilService.checkIsValidEmail(this.Lead['Email']);
      let validPhone = UtilService.checkIsValidPhone(this.Lead['Phone']);
      this.Lead.ModifiedDate = new Date();
      if((this.Lead['Email'] ==''|| this.Lead['Email'] == null ) && (this.Lead['Phone'] ==''|| this.Lead['Phone'] == null )){
        this.emailErrorMessage = this.phoneErrorMessage = "Phone or Email field is mandatory.";
        this.isEmailError = this.isPhoneError = true;
      }
      if(this.Lead['Email'] && !validEmail)
      {
        this.emailErrorMessage = "Please Enter Correct Email.";
        this.isEmailError = true;
      }
      if(this.Lead['Phone'] && !validPhone){
          this.phoneErrorMessage = 'Please enter correct Phone Number.';
          this.isPhoneError = true;
      }
      if(this.isEmailError || this.isPhoneError)
      {
        result = false;
      }
      if (result) {
          this.Lead["Code"] = this.Lead["Code"]
            ? this.Lead["Code"]
            : "";
          if (this.$route.params.leadId) {
            this.Lead["ModifiedBy"] = this.userInfo['Id'];
            LeadService.update(this.$route.params.leadId, this.Lead)
              .then(() => {
                this.$router.push("/apps/leads/list");
                UtilService.notifySuccessAlert(
                  this.$vs,
                  "Lead updated successfully."
                );
                this.fetchLeadData(this.$route.params.leadId);
              })
              .catch(e => {
                console.log(e);
              });
          } else {
            this.Lead["CreatedBy"] = this.userInfo['Id'];
            LeadService.create(this.Lead)
              .then(obj => {
                if (!obj.val()) {
                  this.$router.push("/apps/leads/list");
                  UtilService.notifySuccessAlert(
                    this.$vs,
                    "Lead created successfully."
                  );
                } else {
                  UtilService.notifyErrorAlert(
                    this.$vs,
                    "Lead already exists."
                  );
                }
              })
              .catch(e => {
                console.log(e);
              });
          }
        }
        else{
          UtilService.notifyErrorAlert(
            this.$vs,
            "Please fill all mandatory fields."
          );
        }
      });
    },
    resetCode(){
      this.Code = {
        Id: "",
        Partner: "",
        CodeName: "",
        StartDate: "",
        ExpiryDate: "",
        Primary: "No",
        IsDeleted: 0,
        CreatedBy: "",
        Status: "Active",
        ModifiedBy: ""
      }
    },
    checkIsPartnerExist(){
      this.isPrimaryCodeExist = false;
      if(this.Lead['Partner']){
        this.resetCode(); 
        this.codePopup=true;
      }
      else{
        UtilService.notifyErrorAlert(this.$vs, "Please select partner.");
      }
    },
    saveCode() {
      if (this.Lead["Partner"]) {
        this.Code["Partner"] = this.Lead["Partner"];
        if (this.isChecked) {
          this.Code["Primary"] = "Yes";
          this.Code['ExpiryDate'] = "";
        } else {
          this.Code["Primary"] = "No";
        }
        this.Lead["CreatedBy"] = this.userInfo['Id'];
        if(this.Code && (!this.Code.CodeName || !this.Code.StartDate || (this.Code.Primary === 'No' && !this.Code.ExpiryDate))){
          UtilService.notifyErrorAlert(this.$vs, "Please fill all mandatory fields.");
        } else if(this.Code && this.Code.Primary === 'No' && new Date(this.Code.StartDate) > new Date(this.Code.ExpiryDate)){
          UtilService.notifyErrorAlert(this.$vs, "Start date can not be greater than expiry date.");
        } else if(this.Code && this.Code.Primary === 'No' && (this.Code.ExpiryDate && new Date(this.Code.ExpiryDate) < new Date())){
          UtilService.notifyErrorAlert(this.$vs, "Expiry date can not be in past.");
        } else {
          PartnerCodesService.checkDuplicateCode(this.Code.CodeName, (isExists) => {
            if(isExists === true){
              UtilService.notifyErrorAlert(this.$vs, "Code already exists.");
            } else {
              PartnerCodesService.create(this.Code)
                .then(obj => {
                  this.codePopup = false;
                  UtilService.notifySuccessAlert(
                    this.$vs,
                    "Code created successfully."
                  );
                  this.Lead['Code'] = this.Code['CodeName'];
                  PartnerCodesService.incCodeCount(this.Lead["Partner"]).then(
                    obj => {
                      console.log("partner count updated successfully");
                    }
                  );
                })
                .catch(e => {
                  console.log(e);
                });
            }
          });
        }

      } else {
        UtilService.notifyErrorAlert(this.$vs, "Please select partner.");
      }
    },
    getPartnerVal() {
      let partner = this.userInfo.PartnerId;
      if(this.userInfo.Role == 'Partner Admin' || this.userInfo.Role == 'Partner Staff'){
        PartnerService.getPartnerById(partner).on("value", items => {
          this.partners = [];
          let Partners = [];
          items.forEach(item => {
            let partnerVal = {};
            let key = item.key;
            let data = item.val();
            if (data["IsDeleted"] == 0) {
              partnerVal["label"] = data["CompanyName"];
              partnerVal["value"] = data["Id"];
              this.partners.push(partnerVal);
              this.Lead.Partner = partnerVal.value;
            }
            this.getCodesVal(this.Lead.Partner);
          });
          this.partners.sort((a, b) => a.label.localeCompare(b.label))
        });
      }
      else{
        PartnerService.getAll(this.userInfo).on("value", items => {
        this.partners = [];
        items.forEach(item => {
          let partnerVal = {};
          let key = item.key;
          let data = item.val();
          if (data["IsDeleted"] == 0) {
            partnerVal["label"] = data["CompanyName"];
            partnerVal["value"] = data["Id"];
            this.partners.push(partnerVal);
          }
        });
        this.partners.sort((a, b) => a.label.localeCompare(b.label))
      });
      }
    },
    getCodesVal(partnerId) {
      if(partnerId){
        PartnerCodesService.getCodesVal(partnerId).on("value", items => {
          this.codes = [];
          items.forEach(item => {
            let codesVal = {};
            let key = item.key;
            let data = item.val();
            if (data["IsDeleted"] === 0) {
              if((data['Primary'] == 'Yes') || (new Date(data['ExpiryDate']) >= new Date())){
                codesVal["label"] = data["CodeName"];
                codesVal["value"] = data["Id"];
                this.codes.push(codesVal);
              }
            }
          });
          this.codes.sort((a, b) => a.label.localeCompare(b.label))
        });
      }
    },
    isEmailPhoneValid() {
      this.isEmailError = false;
      this.isPhoneError = false;
      this.emailErrorMessage = '';
      this.phoneErrorMessage = ''
      if((this.Lead['Email'] ==''|| this.Lead['Email'] == null ) && (this.Lead['Phone'] ==''|| this.Lead['Phone'] == null )){
        this.emailErrorMessage = "Phone or Email field is mandatory.";
        this.phoneErrorMessage = "Phone or Email field is mandatory.";
        this.isEmailError = true;
        this.isPhoneError = true;
      }
    },
    resetLead(){
      this.Lead = {
        Id: "",
        CompanyName: "",
        Partner: "",
        Code: "",
        Email: "",
        Phone: "",
        IsConverted:0,
        IsDeleted: 0,
        CreatedBy: "",
        ModifiedBy: "",
        ModifiedDate: Date,
      } 
    }
  },
  computed:{
    userIsManagerOrAdmin () {
      return this.userInfo && (this.userInfo.Role === 'Admin' || this.userInfo.Role === 'Manager')
    },
  },
  watch: {
    '$route' (to, from) {
      this.isSaveForm = false;
      this.resetLead();
    },
  },
  created() {
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    if (this.$route.params.leadId) {
      this.fetchLeadData(this.$route.params.leadId);
    }
    else if(!UtilService.userIsAdminOrManager(this.userInfo.Role)){
      this.Lead.Partner = this.userInfo.PartnerId;
      this.getCodesVal(this.Lead.Partner);
    }
    this.getPartnerVal();
  }
};
</script>
